import { Injectable, ErrorHandler } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { environment } from '../../../environments/environment';

export function initSentry(): void {
  const dsn = (environment as any).sentryDsn;
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment: environment.production ? 'production' : 'development',
    tracesSampleRate: 0.1,
    beforeSend(event) {
      // Strip auth headers
      if (event.request?.headers) {
        delete event.request.headers['Authorization'];
      }
      return event;
    }
  });
}

@Injectable({ providedIn: 'root' })
export class SentryErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    Sentry.captureException(error.originalError || error);
    console.error(error);
  }
}
